import Icon from "../components/Icon";

type HistoryProps = { clientId: string };

export default function History({ clientId }: HistoryProps) {
  void clientId;
  return (
    <div className="page page-enter">
      <div style={{ maxWidth: 1080, margin: "0 auto" }}>
        <div className="section-head">
          <div>
            <span className="eyebrow">Reverse chronological</span>
            <h2 className="t-h2" style={{ marginTop: 10, fontSize: 32 }}>History.</h2>
          </div>
        </div>
        <div className="empty">
          <div className="glyph"><Icon name="history" size={22} /></div>
          <h4 className="t-h4">No deploys yet.</h4>
          <p>
            Every deploy will appear here, newest first: what was in it, who shipped it, and the
            result. Activates once the deploy-history API is live.
          </p>
        </div>
      </div>
    </div>
  );
}
